module.exports = __webpack_public_path__ + "img/Picture18.cbc7402a.png";